import { ActionTypes } from "../constants/actionTypes";

export const setModalAccount = (data) => {
  return {
    type: ActionTypes.SET_MODALACCOUNTS,
    payload: data,
  };
};
